import { render, staticRenderFns } from "./PropertyValueOptionForm.vue?vue&type=template&id=49cce361&scoped=true&lang=pug&"
import script from "./PropertyValueOptionForm.vue?vue&type=script&lang=js&"
export * from "./PropertyValueOptionForm.vue?vue&type=script&lang=js&"
import style0 from "./PropertyValueOptionForm.vue?vue&type=style&index=0&id=49cce361&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cce361",
  null
  
)

/* custom blocks */
import block0 from "./PropertyValueOptionForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports